import React from "react";

import { TypeMini } from "@at/design-system-foundation";

import * as Styles from "./leasing-terms-and-conditions.styles";

export const LeasingTermsAndConditions = () => {
  return (
    <Styles.LeasingTermsAndConditions>
      <TypeMini as="p">
        Monthly rentals (&apos;payments&apos;) are not an offer of credit.
        Payments are based on offers available today which may be withdrawn or
        varied at any time in the future without notice.
      </TypeMini>
      <TypeMini as="p">
        Contract Hire (&apos;Leasing&apos;) is subject to status and approval
        and is only available to UK residents aged 18 and over. Vehicle must be
        returned with no more than fair wear and tear to avoid further charges.
        You will not own the vehicle. Excess mileage charges and return
        conditions apply.
      </TypeMini>
      <TypeMini as="p">
        Auto Trader Limited (Firm Reference Number: 735711) is a credit broker
        and not a lender. Auto Trader Limited introduces you to Autorama UK Ltd
        (Trading as Auto Trader leasing), which acts as a credit broker in its
        own right. Autorama UK Ltd, Maylands Avenue, Hemel Hempstead, HP2 7DE
        (Firm Reference Number: 630748) may go on to introduce you to one of a
        limited number of funders. Autorama UK Ltd will typically receive a
        commission or other benefits from the funder as a result of this
        introduction.
      </TypeMini>
      <TypeMini as="p">
        Autorama UK Ltd is an Auto Trader Group Plc company.
      </TypeMini>
      <TypeMini as="p">
        Vehicles are subject to availability and may vary from images shown.
      </TypeMini>
      <TypeMini as="p" aria-hidden id="required-description">
        *You can only return your lease vehicle for free if you have driven it
        for less than 50 miles (above what was already stated on the mileage
        clock when the vehicle was delivered). The vehicle must also not have
        any damage.
      </TypeMini>
      <TypeMini as="p" aria-hidden id="required-description">
        **We can only deliver to Mainland UK, excluding Northern Ireland.
      </TypeMini>
    </Styles.LeasingTermsAndConditions>
  );
};
